<template>
  <b-modal @hide="modalClose" ref="baseProcessModal" :title="$t('標準工程')" size="xl">
    <b-container fluid>
      <div class="m-3 d-flex flex-row align-items-center justify-content-start form-group">
        <button
          type="button"
          class="btn btn-light mb-3 d-flex align-items-center justify-content-center h-auto"
          :disabled="registering"
          @click="constitutionLink()"
        >
          {{ $t('構成部品表ページに移動') }}
        </button>
      </div>
      <div class="m-3 d-flex flex-row align-items-center justify-content-start form-group">
        <input
          v-model="arrangement"
          type="checkbox"
          id="base-check"
          class="checkbox form-control"
          :disabled="!isArrangeMaterial"
        />
        <label class="label" for="base-check">&nbsp;{{ $t("材料手配工程有り") }}</label>
      </div>
      <template v-for="(item,index) in baseProcessSort">
        <base-process-table-in-house
          v-if="!item.isOutSource"
          :key="index"
          :ref="`baseProcessTable${index}`"
          :processes="processes"
          :processKinds="processKinds"
          :baseProcess="item"
          :timeUnit="timeUnit"
          :users="users"
          :products="products"
          :structures="structures"
          :quantity="form.targets.length"
          @processKindsModalOpen="processKindsModalOpen(item)"
          @changeSort="changeSort($event)"
          @copyProcess="copyProcess(item)"
          @insertProcess="insertProcess(item.sort)"
          @deleteProcess="deleteProcess($event)"
          @changeValue="changeValue($event,item)"
          @changeStructure="changeStructure($event)"
          @addStructure="addStructure($event)"
          @removeStructure="removeStructure($event)"
        ></base-process-table-in-house>
        <base-process-table-outsourcing
          v-else
          :key="index"
          :ref="`baseProcessTable${index}`"
          :processKinds="processKinds"
          :baseProcess="item"
          :structures="structures"
          :quantity="form.targets.length"
          @processKindsModalOpen="processKindsModalOpen(item)"
          @changeSort="changeSort($event)"
          @copyProcess="copyProcess(item)"
          @insertProcess="insertProcess(item.sort)"
          @deleteProcess="deleteProcess($event)"
          @changeValue="changeValue($event,item)"
          @changeStructureValue="changeStructureValue($event)"
          @addStructure="addStructure($event)"
          @removeStructure="removeStructure($event)"
        ></base-process-table-outsourcing>
      </template>
      <b-row>
        <b-col class="form-group">
          <button
            type="button"
            class="btn btn-light mb-3"
            :disabled="registering"
            @click="addProcess()"
          >
            {{ $t('標準工程追加') }}
          </button>
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="error">{{ error }}</p>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-success mb-3 d-flex align-items-center justify-content-center mr-3"
          :disabled="registering"
          @click="register()"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="registering"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t('登録') }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          :disabled="registering"
          @click="modalClose()"
        >{{ $t('キャンセル') }}</button>
      </div>
    </template>
    <process-kinds-modal
    ref="processKinds"
    :processes="processes"
    :processKinds="processKinds"
    :arrangement="arrangement"
    @changeProcessKind="changeProcessKind($event)"
    ></process-kinds-modal>
  </b-modal>
</template>

<script>
import ProcessKindsModal from './processKindsModal'
import baseProcessTableInHouse from './baseProcessTableInHouse'
import baseProcessTableOutsourcing from './baseProcessTableOutsourcing'
import { mapGetters } from 'vuex'
const addFormat = {
  isOutSource: false,
  processKindId: null,
  processId: -1,
  hourPrice: null,
  prepareTime: null,
  machiningTime: null,
  timeUnit: 'min',
  userId: null,
  jig: '',
  tool: '',
  partnerId: -1,
  destId: -1,
  orderCode: '',
  purchasePrice: null,
  leadTime: null,
  note: '',
  sort: null,
  structures: [],
  isDelete: false,
}
export default {
  props: {
    processes: {
      type: Array,
      default: () => [],
    },
    processKinds: {
      type: Array,
      default: () => [],
    },
    structures: {
      type: Object,
      default: () => {},
    },
    users: {
      type: Array,
      default: () => [],
    },
    products: {
      type: Array,
      default: () => [],
    },
    productId: {
      type: Number,
      default: 0,
    },
    isArrangeMaterial: {
      type: Boolean,
      default: false,
    },
  },
  components: { ProcessKindsModal, baseProcessTableInHouse, baseProcessTableOutsourcing },
  data() {
    return {
      // users: [],
      // kinds: [],
      form: {
        productId: null,
        targets: [],
      },
      timeUnit: [
        {name: `${this.$t('秒')}`, value: 'sec'},
        {name: `${this.$t('分')}`, value: 'min'},
        {name: `${this.$t('時間')}`, value: 'hour'},
        {name: `${this.$t('日')}`, value: 'day'},
      ],
      error: '',
      registering: false,
      arrangement: false,
    }
  },
  async created() {
  },
  methods: {
    // モーダルを開いたときの処理
    modalOpen(item) {
      if (item.length != 0) {
        item.map((base, index) => {
          this.form.targets.push(this.mixin_deepcopy(addFormat))
          for (let key of Object.keys(base)) {
            if (key === 'structures') {
              base[key].map((str) => {
                this.form.targets[index][key].push(str)
              })
            } else {
              if (!this.isEmpty(base[key])) this.$set(this.form.targets[index], key, base[key])
            }
          }
        })
        this.form.targets.map(item => {
          if (item.isMaterialPrepare && item.sort === 1) {
            this.arrangement = true
          }
        })
      } else {
        this.addProcess()
      }
      this.form.productId = this.productId
      this.$refs.baseProcessModal.show()
    },
    destroyModal() {
      this.form = {
        productId: null,
        targets: [],
      }
      this.error = ''
      this.registering = false,
      this.arrangement = false,
      this.$refs.baseProcessModal.hide()
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.destroyModal()
      this.$emit('modalClose')
    },
    processKindsModalOpen(item = {}) {
      this.$refs.processKinds.modalOpen(item)
    },
    // 工程区分を変更
    changeProcessKind(event) {
      this.form.targets = this.form.targets.map(item => {
        if (item.sort === event.sort) {
          if (event.isOutSource !== item.isOutSource) {
            for (let key of Object.keys(addFormat)) {
              if (key !== 'sort' && key !== 'productId') item[key] = addFormat[key]
            }
            item.isOutSource = event.isOutSource
          }
          item.processKindId = event.processKindId
          item.processId = null
          item.userId = null
          item.partnerId = null
          item.destId = null
        }
        return item
      })
    },
    // 標準工程を追加
    addProcess() {
      let item = this.mixin_deepcopy(addFormat)
      const sortNum = this.form.targets.filter(item => !item.isDelete)
      item.sort = (sortNum) ? sortNum.length + 1 : 1
      this.form.targets.push(item)
    },
    // 標準工程をコピー
    copyProcess(copy) {
      this.form.targets.map(item => {
        if (item.sort > copy.sort) {
          item.sort++
        }
      })
      let item = this.mixin_deepcopy(copy)
      item.sort = ++item.sort
      delete item.id
      this.form.targets.push(item)
    },
    // 標準工程を挿入
    insertProcess(sort) {
      this.form.targets.map(item => {
        if (item.sort >= sort) {
          item.sort++
        }
      })
      let item = this.mixin_deepcopy(addFormat)
      item.sort = sort
      this.form.targets.push(item)
    },
    // 標準工程を削除
    deleteProcess(sort) {
      if (sort === 1 && this.arrangement) this.arrangement = false
      this.form.targets.map((item) => {
        if (item.sort === sort) {
          this.$set(item, 'sort', -1)
          this.$set(item, 'isDelete', true)
        } else if (item.sort > sort) {
          item.sort--
        }
      })
      this.form.targets.map((item, index) => {
        if (item.isDelete && !item.id) {
          this.form.targets.splice(index, 1)
        }
      })
    },
    // ソートを変更する処理
    changeSort(obj) {
      this.form.targets.map(item => {
        if (obj.direction === 'up' && item.sort === obj.sort) return item.sort--
        if (obj.direction === 'up' && item.sort === (obj.sort - 1)) return item.sort++
        if (obj.direction === 'down' && item.sort === obj.sort) return item.sort++
        if (obj.direction === 'down' && item.sort === (obj.sort + 1)) return item.sort--
      })
    },
    // 値を変更する処理
    changeValue(obj, process) {
      this.form.targets.map(item => {
        if (item.sort === process.sort) {
          if (obj.key === 'partnerId') item.destId = -1
          if (!this.isEmpty(obj.value)) {
            item[obj.key] = (obj.type === 'number') ? Number(obj.value) : obj.value
          } else {
            item[obj.key] = obj.value
          }
        }
        return item
      })
    },
    changeStructure(obj, index, sort) {
      this.form.targets.map(item => {
        if (item.sort === sort) {
          this.$set(item.structures, index, obj)
        }
      })
    },
    // 構成部品の値を変更する処理
    changeStructureValue(obj) {
      this.form.targets.map(item => {
        if (item.sort === obj.sort) {
          if (obj.key === 'name' || obj.key === 'code') {
            this.$set(item.structures[obj.index], obj.key, obj.value)
          } else {
            this.$set(item.structures[obj.index], obj.key, obj.value)
          }
        }
      })
    },
    // 構成部品を追加
    addStructure(obj) {
      this.form.targets.map(item => {
        if (item.sort === obj.sort) {
          item.structures.push({
            id: null,
            quantity: 0,
            productName: '',
            productCode: '',
            productId: null,
            parentProductName: '',
            parentProductCode: '',
            parentProductId: this.productId,
            productProcessId: null,
          })
        }
      })
    },
    // 構成部品を削除
    removeStructure(obj) {
      this.form.targets.map(item => {
        if (item.sort === obj.sort) {
          item.structures.splice(obj.index, 1)
        }
      })
    },
    // 構成部品に遷移
    constitutionLink() {
      let params = {}
      params.productId = this.productId
      window.location.href = process.env.NODE_ENV !== 'development' ? `/base/constitution/index.html?${this.mixinGetUrlParams(params)}` : `/constitution/index.html?${this.mixinGetUrlParams(params)}`
    },
    // 登録処理
    async register() {
      this.error = ''
      for (let i = 0; i < this.form.targets.length; i++) {
        let form = this.form.targets
        if (form[i].isDelete) break
        if (this.isEmpty(form[i].processKindId)) {
          this.error = this.$t('工程区分') + this.$t('必須メッセージ')
          break
        }
        for (let n = 0; n < form[i].structures.length; n++) {
          if (this.isEmpty(form[i].structures[n].id)) {
            this.error = this.$t(`標準工程の${form[i].sort}番目の構成部品を選択して下さい`)
            break
          } else if (this.isEmpty(form[i].structures[n].quantity)) {
            this.error = this.$t('数量') + this.$t('必須メッセージ')
            break
          } else if (form[i].structures[n].quantity <= 0) {
            this.error = this.$t('数量には0より大きい数字を入力して下さい')
            break
          }
        }
        if (this.error) break
      }
      if (this.error) return
      this.registering = true
      let params = {}
      const form = this.mixin_deepcopy(this.form)
      params.productId = form.productId
      let array = []
      form.targets.map(base => {
        let item = {}
        delete base.isMaterialPrepare
        for (let key of Object.keys(base)) {
          if (key === 'processId' || key == 'hourPrice' || key === 'prepareTime' || key === 'machiningTime' || key === 'userId' || key === 'partnerId' || key === 'destId' || key === 'purchasePrice' || key === 'leadTime') {
            item[key] = (!this.isEmpty(base[key])) ? base[key] : -1
            // if(!this.isEmpty(base[key])) item[key] = base[key]
          } else if (key === 'structures') {
            base[key].map(str => {
              delete str.name
              delete str.code
              delete str.disabled
              delete str.purchasePrice
              delete str.productProcessId
            })
            item[key] = base[key]
          } else {
            // item[key] = base[key]
            item[key] = (!this.isEmpty(base[key])) ? base[key] : ''
          }
        }
        array.push(item)
      })
      params.targets = array
      try {
        await this.$axios.put(
          `${this.$appConfig.CommonApiUrl}/product/processes`,
          params,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.destroyModal()
        this.$emit('registered')
      } catch (error) {
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }
      this.registering = false
    },
  },
  computed: {
    baseProcessSort() {
      // FIXME: this.form.targets自体が書き換えられている
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      const sort = this.form.targets.sort((a, b) => {
        return a.sort - b.sort
      })
      return sort.filter(item => !item.isDelete)
    },
    isHouseName() {
      return (id = null) => {
        if (!id) return []
        return this.processes.filter(item => item.processKindId === id && item.userIds.includes(this.userdata.id))
      }
    },
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
  },
  watch: {
    'arrangement': function(newValue) {
      if (newValue) {
        let ret = false
        this.form.targets.map(item => {
          if (item.isMaterialPrepare && item.sort === 1) {
            ret = true
          }
        })
        if (ret) return
        this.form.targets.map(item => {
          if (item.sort >= 1) {
            item.sort++
          }
        })
        let item = this.mixin_deepcopy(addFormat)
        item.sort = 1
        item.isOutSource = true
        item.processKindId = 108
        this.form.targets.push(item)
      } else {
        this.form.targets.map(item => {
          if (item.sort === 1) {
            this.$set(item, 'isMaterialPrepare', false)
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#baseProcessModal {
  .modal-dialog {
    max-width: 150rem;
  }
}
</style>
